import { TableComment } from "../../../../general/src/TableComment";
import { CityState, DataSource, Label, Layout, LayoutHeader, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLateRouteView extends Layout {
    citystateNextStop: CityState;
    citystatePrevStop: CityState;
    labelD: Label;
    labelDistanceToStop: Label;
    labelDistanceToStopCaption: Label;
    labelG: Label;
    labelMovement: Label;
    labelMovementNumber: Label;
    labelNonstopDiff: Label;
    labelO: Label;
    labelOrder: Label;
    labelOrderNumber: Label;
    labelPlannedDiff: Label;
    labelProjectedDiff: Label;
    labelStopDetails: Label;
    layoutTableComment: TableComment;
    layoutheaderLateRouteHistory: LayoutHeader;
    panelDistToStop: Panel;
    panelEquipmentInfo: Panel;
    panelGen1: Panel;
    panelGen2: Panel;
    panelGen3: Panel;
    panelGeneral: Panel;
    panelGeneralInfo: Panel;
    panelMovement: Panel;
    panelOrder: Panel;
    panelOutOfRouteComp: Panel;
    panelOutOfRouteDetails: Panel;
    panelStop1: Panel;
    panelStop2: Panel;
    panelStop3: Panel;
    panelStop4: Panel;
    panelStopDetails: Panel;
    sourceComments: DataSource;
    sourceLateRouteHistory: DataSource;
    sourceLateRouteView: DataSource;
    switchActual: Switch;
    switchCurrent: Switch;
    switchProjectedLate: Switch;
    switchProjectedOutOfRoute: Switch;
    switchTeamDrivers: Switch;
    tabComments: Tab;
    tabGeneral: Tab;
    tabHistory: Tab;
    tabLateRoute: Tab;
    tableLateRouteHistory: Table;
    tabsetLateRouteInfo: Tabset;
    tabsetMain: Tabset;
    textboxCreatedFrom: Textbox;
    textboxCreatedOn: Textbox;
    textboxDepartDate: Textbox;
    textboxDriver: Textbox;
    textboxDriverActivity: Textbox;
    textboxEarlySchedArrival: Textbox;
    textboxHoursToRequiredBreak: Textbox;
    textboxInboundZone: Textbox;
    textboxLateRouteStatus: Textbox;
    textboxLateSchedArrival: Textbox;
    textboxNonstopArrivalTime: Textbox;
    textboxOutOfRouteDistance: Textbox;
    textboxOutOfRoutePercent: Textbox;
    textboxOutboundZone: Textbox;
    textboxPlannedTime: Textbox;
    textboxProjectedArrivalTime: Textbox;
    textboxTractor: Textbox;
    textboxTractorLastLocation: Textbox;
    textboxTrailer: Textbox;
    textboxTravelTime: Textbox;
    textboxUnloadTime: Textbox;
}
